import { LoggingService } from "./../helpers/logging-service";
export class MongoManageTable {
    constructor({ mongoDb, secondaryIndexOptions, tableFullName, partitionKeyFieldName, sortKeyFieldName, }) {
        Object.defineProperty(this, "partitionKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sortKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mongoDb", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableFullName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "secondaryIndexOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.mongoDb = mongoDb;
        this.tableFullName = tableFullName;
        this.partitionKeyFieldName = partitionKeyFieldName;
        this.sortKeyFieldName = sortKeyFieldName;
        this.secondaryIndexOptions = secondaryIndexOptions;
        this._trickLinter();
    }
    _trickLinter() {
        if (this.partitionKeyFieldName && this.sortKeyFieldName && this.tableFullName) {
        }
    }
    _fuse_getInstance() {
        return this.mongoDb().getDbInstance();
    }
    async fuse_createIndex({ indexName, fields }) {
        const db = await this._fuse_getInstance();
        const indexObject = {};
        fields.forEach((key) => {
            indexObject[key] = 1;
        });
        const result = await db.createIndex(indexObject, { name: indexName });
        LoggingService.log(result);
        return result;
    }
    async fuse_clearAllIndexes() {
        const db = await this._fuse_getInstance();
        const indexes = await this.fuse_getIndexes();
        const dropedIndexes = [];
        if (indexes?.length) {
            for (const index01 of indexes) {
                if (index01.name !== "_id_") {
                    await db.dropIndex(index01.name);
                    dropedIndexes.push(index01);
                }
            }
        }
        return {
            indexes,
            dropedIndexes,
        };
    }
    async fuse_getIndexes() {
        const db = await this._fuse_getInstance();
        const indexes = await db.indexes();
        return indexes;
    }
    async fuse_createDefinedIndexes() {
        const results = [];
        if (this.secondaryIndexOptions?.length) {
            for (const indexOption of this.secondaryIndexOptions) {
                if (indexOption.indexName) {
                    const resultData = await this.fuse_createIndex({
                        fields: [indexOption.partitionKeyFieldName, indexOption.sortKeyFieldName],
                        indexName: indexOption.indexName,
                    });
                    LoggingService.log(resultData);
                    results.push(resultData);
                }
            }
        }
        return results;
    }
}
